import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import API from '../../utils/api';
import toast from 'react-hot-toast';

const BODEGAS_PDV = [
  { id: 2, nombre: 'Nuestro' },
  { id: 3, nombre: 'Buenavista' },
  { id: 4, nombre: 'Alamedas' },
  { id: 5, nombre: 'Parque Alegra' },
  { id: 6, nombre: 'Centro Histórico' },
  { id: 7, nombre: 'Pueblito Cordobés' },
];
// Igual a BODEGAS_PDV pero con Producción — solo para la sección de Sabores
// de Helado (bodegas_aplica ahí sí puede referirse a Producción). No se usa
// BODEGAS_PDV directo para no afectar la grilla de lead time/pedido mínimo
// de ítems de inventario, donde Producción no aplica.
const BODEGAS_SABORES = [...BODEGAS_PDV, { id: 1, nombre: 'Producción' }];

const st = {
  label: { fontSize: 11, fontWeight: 700, color: '#6B7280', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 4, display: 'block' },
  input: { padding: '8px 12px', border: '2px solid #E5E7EB', borderRadius: 8, fontSize: 13, outline: 'none', background: 'white', width: '100%', boxSizing: 'border-box' },
};

// ── Gestión ítems inventario general ──────────────────────
export function TabGestionItems() {
  const { puedeVer } = useAuth();
  const [items, setItems]         = useState([]);
  const [busqueda, setBusqueda]   = useState('');
  const [modal, setModal]         = useState(false);
  const [editando, setEditando]   = useState(null);
  const [guardando, setGuardando] = useState(false);
  const [mostrarInactivos, setMostrarInactivos] = useState(false);
  const [form, setForm] = useState({
    nombre: '', unidad_medida: 'Unidad exacta', categoria: 'insumos',
    aplica_diario: true, aplica_semanal: true,
    aplica_pa: true, aplica_pdv: true,
    bodegas_aplica: [], activo: true,
    empaque_cantidad: 1, empaque_nombre: '', produccion_item_id: ''
  });
  const [minimos, setMinimos] = useState({}); // { bodega_id: valor }
  const [guardandoMinimos, setGuardandoMinimos] = useState(false);
  const [produccionItems, setProduccionItems] = useState([]);

  if (!puedeVer('gerencia', 'administracion')) return null;

  useEffect(() => { cargar(); }, []);

  const cargar = () => {
    API.get('/inventario/items-admin').then(r => setItems(r.data)).catch(() => toast.error('Error cargando ítems'));
    API.get('/inventario/produccion-items-simple').then(r => setProduccionItems(r.data)).catch(() => {});
  };

  const abrirNuevo = () => {
    setEditando(null);
    setForm({ nombre:'', unidad_medida:'Unidad exacta', categoria:'insumos', aplica_diario:true, aplica_semanal:true, aplica_pa:true, aplica_pdv:true, bodegas_aplica:[], activo:true, empaque_cantidad:1, empaque_nombre:'', produccion_item_id:'' });
    setMinimos({});
    setModal(true);
  };

  const abrirEditar = (item) => {
    setEditando(item.id);
    setForm({
      nombre: item.nombre, unidad_medida: item.unidad_medida||'Unidad exacta',
      categoria: item.categoria||'insumos',
      aplica_diario: item.aplica_diario, aplica_semanal: item.aplica_semanal,
      aplica_pa: item.aplica_pa, aplica_pdv: item.aplica_pdv,
      bodegas_aplica: item.bodegas_aplica || [],
      activo: item.activo,
      empaque_cantidad: item.empaque_cantidad || 1,
      empaque_nombre: item.empaque_nombre || '',
      produccion_item_id: item.produccion_item_id || ''
    });
    const m = {};
    (item.minimos_pdv || []).forEach(x => { m[x.bodega_id] = { lead_time_dias: x.lead_time_dias, pedido_minimo: x.pedido_minimo }; });
    setMinimos(m);
    setModal(true);
  };

  const guardar = async () => {
    if (!form.nombre) { toast.error('El nombre es requerido'); return; }
    setGuardando(true);
    try {
      let itemId = editando;
      if (editando) await API.put(`/inventario/items-admin/${editando}`, form);
      else { const r = await API.post('/inventario/items-admin', form); itemId = r.data.id; }
      // Guardar mínimos por PDV (solo si aplica a inventario semanal)
      if (form.aplica_semanal) {
        const payload = Object.entries(minimos)
          .filter(([, v]) => (v?.lead_time_dias !== '' && v?.lead_time_dias != null) || (v?.pedido_minimo !== '' && v?.pedido_minimo != null))
          .map(([bodega_id, v]) => ({ bodega_id: parseInt(bodega_id), lead_time_dias: v.lead_time_dias, pedido_minimo: v.pedido_minimo }));
        await API.put(`/inventario/minimos-pdv/${itemId}`, { minimos: payload });
      }
      toast.success(editando ? 'Ítem actualizado' : 'Ítem creado');
      setModal(false); cargar();
    } catch { toast.error('Error al guardar'); }
    finally { setGuardando(false); }
  };

  const desactivar = async (id) => {
    if (!window.confirm('¿Desactivar este ítem?')) return;
    try { await API.delete(`/inventario/items-admin/${id}`); toast.success('Desactivado'); cargar(); }
    catch { toast.error('Error'); }
  };

  const toggleBodega = (id) => {
    setForm(f => ({
      ...f,
      bodegas_aplica: f.bodegas_aplica.includes(id)
        ? f.bodegas_aplica.filter(b => b !== id)
        : [...f.bodegas_aplica, id]
    }));
  };

  const filtrados = items.filter(i =>
    (mostrarInactivos || i.activo) &&
    i.nombre.toLowerCase().includes(busqueda.toLowerCase())
  );

  const CATEGORIAS = ['insumos', 'empaques', 'aseo', 'papeleria', 'utensilios', 'ingredientes'];

  return (
    <div>
      <div style={{ background: '#FEF3C7', borderRadius: 10, padding: '10px 16px', marginBottom: 14, fontSize: 13, color: '#92400E' }}>
        ⚠️ Esta pestaña es solo para gerencia. Los cambios afectan lo que ven todos los PDVs en sus inventarios.
      </div>

      <div style={{ display:'flex', gap:10, marginBottom:14, flexWrap:'wrap', alignItems:'center' }}>
        <input value={busqueda} onChange={e=>setBusqueda(e.target.value)} placeholder="Buscar ítem..." style={{...st.input, maxWidth:280}} />
        <label style={{ display:'flex', alignItems:'center', gap:6, fontSize:13, cursor:'pointer', color:'#6B7280' }}>
          <input type="checkbox" checked={mostrarInactivos} onChange={e=>setMostrarInactivos(e.target.checked)} />
          Mostrar inactivos
        </label>
        <div style={{ marginLeft:'auto', fontSize:13, color:'#6B7280' }}>{filtrados.length} ítems</div>
        <button onClick={abrirNuevo} style={{ padding:'8px 18px', background:'#2563EB', color:'white', border:'none', borderRadius:8, cursor:'pointer', fontSize:13, fontWeight:700 }}>+ Nuevo ítem</button>
      </div>

      <div style={{ background:'white', borderRadius:14, overflow:'hidden', boxShadow:'0 1px 4px rgba(0,0,0,0.07)' }}>
        <table style={{ width:'100%', borderCollapse:'collapse', fontSize:13 }}>
          <thead>
            <tr style={{ background:'#F9FAFB' }}>
              {['Nombre','Categoría','Unidad','D','S','Lead time','PDVs','Estado',''].map(h => (
                <th key={h} style={{ padding:'10px 12px', textAlign:'left', fontSize:11, fontWeight:700, color:'#6B7280', textTransform:'uppercase' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtrados.map((item, i) => (
              <tr key={item.id} style={{ borderTop:'1px solid #F3F4F6', background: !item.activo?'#FEF2F2':i%2===0?'white':'#FAFAFA' }}>
                <td style={{ padding:'9px 12px', fontWeight:600, color:item.activo?'#111827':'#9CA3AF' }}>
                  {item.nombre}
                  {item.produccion_item_nombre && <div style={{ fontSize:10, color:'#7C3AED', fontWeight:600 }}>🏭 {item.produccion_item_nombre}</div>}
                </td>
                <td style={{ padding:'9px 12px', color:'#6B7280', fontSize:12 }}>{item.categoria}</td>
                <td style={{ padding:'9px 12px', color:'#6B7280', fontSize:12 }}>{item.unidad_medida}</td>
                <td style={{ padding:'9px 12px', textAlign:'center' }}>{item.aplica_diario ? '✅' : '—'}</td>
                <td style={{ padding:'9px 12px', textAlign:'center' }}>{item.aplica_semanal ? '✅' : '—'}</td>
                <td style={{ padding:'9px 12px', textAlign:'center', fontWeight:700, color:'#0369A1', fontSize:11 }}>
                  {(() => {
                    const lts = (item.minimos_pdv || []).map(m => parseFloat(m.lead_time_dias)).filter(v => !isNaN(v));
                    if (!lts.length) return '—';
                    const min = Math.min(...lts), max = Math.max(...lts);
                    return (
                      <>
                        {min === max ? `${min}d` : `${min}–${max}d`}
                        <div style={{ fontSize:10, color:'#9CA3AF', fontWeight:400 }}>{item.minimos_pdv.length} PDV</div>
                      </>
                    );
                  })()}
                  {item.empaque_cantidad > 1 && <div style={{ fontSize:10, color:'#9CA3AF', fontWeight:400 }}>x{item.empaque_cantidad} {item.empaque_nombre||''}</div>}
                </td>
                <td style={{ padding:'9px 12px', fontSize:11, color:'#6B7280' }}>
                  {item.bodegas_aplica?.length
                    ? item.bodegas_aplica.map(id => BODEGAS_PDV.find(b=>b.id===id)?.nombre||id).join(', ')
                    : <span style={{ color:'#059669', fontWeight:600 }}>Todos</span>}
                </td>
                <td style={{ padding:'9px 12px' }}>
                  <span style={{ fontSize:11, fontWeight:700, padding:'2px 8px', borderRadius:6, background:item.activo?'#D1FAE5':'#FEE2E2', color:item.activo?'#065F46':'#991B1B' }}>
                    {item.activo ? 'Activo' : 'Inactivo'}
                  </span>
                </td>
                <td style={{ padding:'9px 12px' }}>
                  <div style={{ display:'flex', gap:4 }}>
                    <button onClick={() => abrirEditar(item)} style={{ padding:'4px 10px', border:'1px solid #E5E7EB', borderRadius:6, background:'white', cursor:'pointer', fontSize:12 }}>✏️</button>
                    {item.activo && <button onClick={() => desactivar(item.id)} style={{ padding:'4px 10px', border:'1px solid #FECACA', borderRadius:6, background:'white', color:'#EF4444', cursor:'pointer', fontSize:12 }}>Desactivar</button>}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {modal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:2000, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
          <div style={{ background:'white', borderRadius:16, width:'100%', maxWidth:560, maxHeight:'90vh', overflowY:'auto' }}>
            <div style={{ background:'#1a1a2e', padding:'14px 22px', borderRadius:'16px 16px 0 0', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
              <span style={{ color:'white', fontWeight:800 }}>{editando ? '✏️ Editar ítem' : '+ Nuevo ítem de inventario'}</span>
              <button onClick={()=>setModal(false)} style={{ background:'none', border:'none', color:'white', fontSize:20, cursor:'pointer' }}>×</button>
            </div>
            <div style={{ padding:22, display:'flex', flexDirection:'column', gap:14 }}>
              <div><span style={st.label}>Nombre *</span><input value={form.nombre} onChange={e=>setForm(f=>({...f,nombre:e.target.value}))} placeholder="Nombre del ítem" style={st.input} /></div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
                <div>
                  <span style={st.label}>Categoría</span>
                  <select value={form.categoria} onChange={e=>setForm(f=>({...f,categoria:e.target.value}))} style={st.input}>
                    {CATEGORIAS.map(c => <option key={c} value={c}>{c}</option>)}
                  </select>
                </div>
                <div><span style={st.label}>Unidad de medida</span><input value={form.unidad_medida} onChange={e=>setForm(f=>({...f,unidad_medida:e.target.value}))} style={st.input} /></div>
              </div>

              {/* Tipo inventario */}
              <div>
                <span style={st.label}>Aplica en</span>
                <div style={{ display:'flex', gap:16 }}>
                  {[['aplica_diario','Inventario diario'],['aplica_semanal','Inventario semanal']].map(([key,label]) => (
                    <label key={key} style={{ display:'flex', alignItems:'center', gap:6, fontSize:13, cursor:'pointer' }}>
                      <input type="checkbox" checked={form[key]} onChange={e=>setForm(f=>({...f,[key]:e.target.checked}))} />
                      {label}
                    </label>
                  ))}
                </div>
              </div>

              {/* Vínculo con el catálogo de producción — para que los envíos
                  desde planta descuenten el ítem correcto, sin depender de que
                  el nombre coincida exacto entre los dos catálogos */}
              <div style={{ background:'#F5F3FF', border:'1px solid #DDD6FE', borderRadius:10, padding:14 }}>
                <span style={{ ...st.label, color:'#5B21B6' }}>🏭 Vinculado con producción (opcional)</span>
                <div style={{ fontSize:11, color:'#4C1D95', marginBottom:8 }}>
                  Si este ítem lo despacha producción (no se compra directo en el PDV), vincúlalo con su ítem correspondiente en el catálogo de Materia Prima — así el envío descuenta bien el stock de planta.
                </div>
                <select value={form.produccion_item_id} onChange={e=>setForm(f=>({...f,produccion_item_id:e.target.value}))} style={st.input}>
                  <option value="">— No viene de producción / comprar directo —</option>
                  {produccionItems.map(p => <option key={p.id} value={p.id}>{p.nombre} ({p.categoria})</option>)}
                </select>
              </div>

              {/* Reposición semanal — un mínimo por PDV, más el empaque (global) */}
              {form.aplica_semanal && (
                <div style={{ background:'#F0F9FF', border:'1px solid #BAE6FD', borderRadius:10, padding:14 }}>
                  <span style={{ ...st.label, color:'#0369A1' }}>📦 Reposición semanal (para la alerta automática)</span>

                  <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginTop:8, marginBottom:12 }}>
                    <div>
                      <span style={st.label}>Unidades por empaque</span>
                      <input type="number" min="1" value={form.empaque_cantidad} onChange={e=>setForm(f=>({...f,empaque_cantidad:e.target.value}))} placeholder="Ej: 500" style={st.input} />
                    </div>
                    <div>
                      <span style={st.label}>Nombre del empaque</span>
                      <input value={form.empaque_nombre} onChange={e=>setForm(f=>({...f,empaque_nombre:e.target.value}))} placeholder="Caja, bolsa..." style={st.input} />
                    </div>
                  </div>
                  <div style={{ fontSize:11, color:'#6B7280', marginBottom:12 }}>
                    Si no viene en empaque cerrado (se puede pedir suelto), deja "Unidades por empaque" en 1. El empaque es el mismo para todos los PDVs.
                  </div>

                  <span style={st.label}>Por PDV — lead time y pedido mínimo</span>
                  <div style={{ display:'grid', gridTemplateColumns:'110px 1fr 1fr', gap:8, marginTop:6, alignItems:'center' }}>
                    <div></div>
                    <div style={{ fontSize:10, color:'#6B7280', fontWeight:700, textTransform:'uppercase' }}>Lead time (días)</div>
                    <div style={{ fontSize:10, color:'#6B7280', fontWeight:700, textTransform:'uppercase' }}>Pedido mínimo (lo menos que se pide)</div>
                    {BODEGAS_PDV.map(b => (
                      <React.Fragment key={b.id}>
                        <span style={{ fontSize:12, color:'#374151' }}>{b.nombre}</span>
                        <input type="number" min="0" step="0.5" value={minimos[b.id]?.lead_time_dias ?? ''}
                          onChange={e=>setMinimos(m=>({...m,[b.id]:{...(m[b.id]||{}),lead_time_dias:e.target.value}}))}
                          placeholder="—" style={{ ...st.input, padding:'6px 10px' }} />
                        <input type="number" min="0" value={minimos[b.id]?.pedido_minimo ?? ''}
                          onChange={e=>setMinimos(m=>({...m,[b.id]:{...(m[b.id]||{}),pedido_minimo:e.target.value}}))}
                          placeholder="—" style={{ ...st.input, padding:'6px 10px' }} />
                      </React.Fragment>
                    ))}
                  </div>
                  <div style={{ fontSize:11, color:'#6B7280', marginTop:8 }}>
                    El "lead time" es cuántos días tarda en llegar el pedido a ese PDV — con eso el sistema calcula solo cuándo reponer (ya no se digita un mínimo fijo). Deja en blanco los PDVs donde no aplique este ítem. El "pedido mínimo" es opcional — solo úsalo si a ese PDV no le pueden mandar menos de cierta cantidad de una vez (ej. Cartagena: mínimo 2 cajas de conos aunque el faltante sea menor).
                  </div>
                </div>
              )}

              {/* PDVs */}
              <div>
                <span style={st.label}>PDVs donde aplica</span>
                <div style={{ marginBottom:8 }}>
                  <label style={{ display:'flex', alignItems:'center', gap:6, fontSize:13, cursor:'pointer', marginBottom:8 }}>
                    <input type="checkbox"
                      checked={form.bodegas_aplica.length === 0}
                      onChange={e => { if(e.target.checked) setForm(f=>({...f,bodegas_aplica:[]})); }}
                    />
                    <span style={{ fontWeight:700, color:'#059669' }}>✅ Todos los PDVs</span>
                  </label>
                  <div style={{ display:'flex', flexWrap:'wrap', gap:8 }}>
                    {BODEGAS_PDV.map(b => (
                      <label key={b.id} style={{ display:'flex', alignItems:'center', gap:6, fontSize:13, cursor:'pointer',
                        padding:'5px 12px', border:`2px solid ${form.bodegas_aplica.includes(b.id)?'#2563EB':'#E5E7EB'}`,
                        borderRadius:8, background: form.bodegas_aplica.includes(b.id)?'#EFF6FF':'white' }}>
                        <input type="checkbox" checked={form.bodegas_aplica.includes(b.id)} onChange={()=>toggleBodega(b.id)} style={{ display:'none' }} />
                        {b.nombre}
                      </label>
                    ))}
                  </div>
                </div>
              </div>

              <div style={{ display:'flex', gap:16 }}>
                <label style={{ display:'flex', alignItems:'center', gap:6, fontSize:13, cursor:'pointer' }}>
                  <input type="checkbox" checked={form.activo} onChange={e=>setForm(f=>({...f,activo:e.target.checked}))} />
                  Activo
                </label>
              </div>

              <div style={{ display:'flex', gap:10, justifyContent:'flex-end', marginTop:6 }}>
                <button onClick={()=>setModal(false)} style={{ padding:'9px 18px', border:'2px solid #E5E7EB', borderRadius:10, background:'white', cursor:'pointer', fontSize:13 }}>Cancelar</button>
                <button onClick={guardar} disabled={guardando} style={{ padding:'9px 24px', border:'none', borderRadius:10, background:'#2563EB', color:'white', cursor:'pointer', fontSize:13, fontWeight:700 }}>
                  {guardando ? '⏳' : editando ? '💾 Actualizar' : '💾 Crear'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── Gestión sabores helado ─────────────────────────────────
export function TabGestionSabores() {
  const { puedeVer } = useAuth();
  const [sabores, setSabores]     = useState([]);
  const [busqueda, setBusqueda]   = useState('');
  const [modal, setModal]         = useState(false);
  const [editando, setEditando]   = useState(null);
  const [guardando, setGuardando] = useState(false);
  const [mostrarInactivos, setMostrarInactivos] = useState(false);
  const [form, setForm] = useState({
    nombre: '', es_premium: false, precio_adicional: 0,
    bodegas_aplica: [], activo: true
  });

  if (!puedeVer('gerencia')) return null;

  useEffect(() => { cargar(); }, []);

  const cargar = () => {
    API.get('/helados/sabores-admin').then(r => setSabores(r.data)).catch(() => toast.error('Error cargando sabores'));
  };

  const abrirNuevo = () => {
    setEditando(null);
    setForm({ nombre:'', es_premium:false, precio_adicional:0, bodegas_aplica:[], activo:true });
    setModal(true);
  };

  const abrirEditar = (s) => {
    setEditando(s.id);
    setForm({ nombre:s.nombre, es_premium:s.es_premium, precio_adicional:s.precio_adicional||0, bodegas_aplica:s.bodegas_aplica||[], activo:s.activo });
    setModal(true);
  };

  const guardar = async () => {
    if (!form.nombre) { toast.error('El nombre es requerido'); return; }
    setGuardando(true);
    try {
      if (editando) await API.put(`/helados/sabores-admin/${editando}`, form);
      else          await API.post('/helados/sabores-admin', form);
      toast.success(editando ? 'Sabor actualizado' : 'Sabor creado');
      setModal(false); cargar();
    } catch { toast.error('Error al guardar'); }
    finally { setGuardando(false); }
  };

  const desactivar = async (id) => {
    if (!window.confirm('¿Desactivar este sabor?')) return;
    try { await API.delete(`/helados/sabores-admin/${id}`); toast.success('Desactivado'); cargar(); }
    catch { toast.error('Error'); }
  };

  const toggleBodega = (id) => {
    setForm(f => ({
      ...f,
      bodegas_aplica: f.bodegas_aplica.includes(id)
        ? f.bodegas_aplica.filter(b => b !== id)
        : [...f.bodegas_aplica, id]
    }));
  };

  const filtrados = sabores.filter(s =>
    (mostrarInactivos || s.activo) &&
    s.nombre.toLowerCase().includes(busqueda.toLowerCase())
  );

  return (
    <div>
      <div style={{ background:'#FEF3C7', borderRadius:10, padding:'10px 16px', marginBottom:14, fontSize:13, color:'#92400E' }}>
        ⚠️ Esta pestaña es solo para gerencia. Los cambios afectan lo que ven todos los PDVs en su inventario de helados.
      </div>

      <div style={{ display:'flex', gap:10, marginBottom:14, flexWrap:'wrap', alignItems:'center' }}>
        <input value={busqueda} onChange={e=>setBusqueda(e.target.value)} placeholder="Buscar sabor..." style={{...st.input, maxWidth:280}} />
        <label style={{ display:'flex', alignItems:'center', gap:6, fontSize:13, cursor:'pointer', color:'#6B7280' }}>
          <input type="checkbox" checked={mostrarInactivos} onChange={e=>setMostrarInactivos(e.target.checked)} />
          Mostrar inactivos
        </label>
        <div style={{ marginLeft:'auto', fontSize:13, color:'#6B7280' }}>{filtrados.length} sabores</div>
        <button onClick={abrirNuevo} style={{ padding:'8px 18px', background:'#2563EB', color:'white', border:'none', borderRadius:8, cursor:'pointer', fontSize:13, fontWeight:700 }}>+ Nuevo sabor</button>
      </div>

      <div style={{ background:'white', borderRadius:14, overflow:'hidden', boxShadow:'0 1px 4px rgba(0,0,0,0.07)' }}>
        <table style={{ width:'100%', borderCollapse:'collapse', fontSize:13 }}>
          <thead>
            <tr style={{ background:'#F9FAFB' }}>
              {['Sabor','Premium','PDVs donde aplica','Estado',''].map(h => (
                <th key={h} style={{ padding:'10px 12px', textAlign:'left', fontSize:11, fontWeight:700, color:'#6B7280', textTransform:'uppercase' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtrados.map((s, i) => (
              <tr key={s.id} style={{ borderTop:'1px solid #F3F4F6', background:!s.activo?'#FEF2F2':i%2===0?'white':'#FAFAFA' }}>
                <td style={{ padding:'9px 12px', fontWeight:700, color:s.activo?'#111827':'#9CA3AF' }}>{s.nombre}</td>
                <td style={{ padding:'9px 12px', textAlign:'center' }}>{s.es_premium ? '⭐' : '—'}</td>
                <td style={{ padding:'9px 12px', fontSize:11, color:'#6B7280' }}>
                  {s.bodegas_aplica?.length
                    ? s.bodegas_aplica.map(id => BODEGAS_SABORES.find(b=>b.id===id)?.nombre||id).join(', ')
                    : <span style={{ color:'#059669', fontWeight:600 }}>Todos los PDVs</span>}
                </td>
                <td style={{ padding:'9px 12px' }}>
                  <span style={{ fontSize:11, fontWeight:700, padding:'2px 8px', borderRadius:6, background:s.activo?'#D1FAE5':'#FEE2E2', color:s.activo?'#065F46':'#991B1B' }}>
                    {s.activo ? 'Activo' : 'Inactivo'}
                  </span>
                </td>
                <td style={{ padding:'9px 12px' }}>
                  <div style={{ display:'flex', gap:4 }}>
                    <button onClick={()=>abrirEditar(s)} style={{ padding:'4px 10px', border:'1px solid #E5E7EB', borderRadius:6, background:'white', cursor:'pointer', fontSize:12 }}>✏️</button>
                    {s.activo && <button onClick={()=>desactivar(s.id)} style={{ padding:'4px 10px', border:'1px solid #FECACA', borderRadius:6, background:'white', color:'#EF4444', cursor:'pointer', fontSize:12 }}>Desactivar</button>}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {modal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:2000, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
          <div style={{ background:'white', borderRadius:16, width:'100%', maxWidth:500, maxHeight:'90vh', overflowY:'auto' }}>
            <div style={{ background:'#1a1a2e', padding:'14px 22px', borderRadius:'16px 16px 0 0', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
              <span style={{ color:'white', fontWeight:800 }}>{editando ? '✏️ Editar sabor' : '🍦 Nuevo sabor'}</span>
              <button onClick={()=>setModal(false)} style={{ background:'none', border:'none', color:'white', fontSize:20, cursor:'pointer' }}>×</button>
            </div>
            <div style={{ padding:22, display:'flex', flexDirection:'column', gap:14 }}>
              <div><span style={st.label}>Nombre *</span><input value={form.nombre} onChange={e=>setForm(f=>({...f,nombre:e.target.value}))} placeholder="Nombre del sabor" style={st.input} /></div>
              <label style={{ display:'flex', alignItems:'center', gap:8, fontSize:13, cursor:'pointer' }}>
                <input type="checkbox" checked={form.es_premium} onChange={e=>setForm(f=>({...f,es_premium:e.target.checked}))} />
                <span>⭐ Sabor premium</span>
              </label>

              {/* PDVs */}
              <div>
                <span style={st.label}>PDVs donde aplica</span>
                <label style={{ display:'flex', alignItems:'center', gap:6, fontSize:13, cursor:'pointer', marginBottom:8 }}>
                  <input type="checkbox"
                    checked={form.bodegas_aplica.length === 0}
                    onChange={e => { if(e.target.checked) setForm(f=>({...f,bodegas_aplica:[]})); }}
                  />
                  <span style={{ fontWeight:700, color:'#059669' }}>✅ Todos los PDVs</span>
                </label>
                <div style={{ display:'flex', flexWrap:'wrap', gap:8 }}>
                  {BODEGAS_SABORES.map(b => (
                    <label key={b.id} style={{ display:'flex', alignItems:'center', gap:6, fontSize:13, cursor:'pointer',
                      padding:'5px 12px', border:`2px solid ${form.bodegas_aplica.includes(b.id)?'#2563EB':'#E5E7EB'}`,
                      borderRadius:8, background:form.bodegas_aplica.includes(b.id)?'#EFF6FF':'white' }}>
                      <input type="checkbox" checked={form.bodegas_aplica.includes(b.id)} onChange={()=>toggleBodega(b.id)} style={{ display:'none' }} />
                      {b.nombre}
                    </label>
                  ))}
                </div>
              </div>

              <label style={{ display:'flex', alignItems:'center', gap:6, fontSize:13, cursor:'pointer' }}>
                <input type="checkbox" checked={form.activo} onChange={e=>setForm(f=>({...f,activo:e.target.checked}))} />
                Activo
              </label>

              <div style={{ display:'flex', gap:10, justifyContent:'flex-end', marginTop:6 }}>
                <button onClick={()=>setModal(false)} style={{ padding:'9px 18px', border:'2px solid #E5E7EB', borderRadius:10, background:'white', cursor:'pointer', fontSize:13 }}>Cancelar</button>
                <button onClick={guardar} disabled={guardando} style={{ padding:'9px 24px', border:'none', borderRadius:10, background:'#2563EB', color:'white', cursor:'pointer', fontSize:13, fontWeight:700 }}>
                  {guardando ? '⏳' : editando ? '💾 Actualizar' : '💾 Crear'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
